module.exports = __webpack_public_path__ + "static/media/hero-background.d918b3f9.jpg";